module.exports = __webpack_public_path__ + "img/icon87.de8e216d.png";